import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { List, ListItem } from '@chakra-ui/react';
import { CircularProgress, Progress } from '../Progress/component.js';
import { Image } from '../Image/component.js';
import IconButton from '../IconButton/component.js';
import Button from '../Button/component.js';
import { Layout } from '../Layout/component.js';
import { Typography } from '../Typography/component.js';

var ContentList = function ContentList(_ref) {
  var items = _ref.items,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      textStyle = _ref.textStyle;
  return /*#__PURE__*/React.createElement(List, {
    variant: "contentList",
    "data-testid": "core-content-list"
  }, items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.key || "".concat(item.heading, "-").concat(index),
      py: "md"
    }, /*#__PURE__*/React.createElement(Layout, {
      variant: "grid",
      gap: "xs",
      gridTemplateColumns: ['1fr', null, 'auto 1fr', null, null],
      alignItems: ['start', null, 'center', 'center', null]
    }, /*#__PURE__*/React.createElement(Layout, {
      borderRadius: "8px",
      overflow: "hidden",
      maxWidth: ['auto', null, 200, null, null]
    }, variant === 'withCircularProgress' ? item.progress !== undefined && /*#__PURE__*/React.createElement(CircularProgress, {
      value: item.progress,
      shapeSize: '20px',
      thickness: '17px',
      colorScheme: item.colorScheme
    }) : /*#__PURE__*/React.createElement(Image, {
      path: item.image || ''
    })), /*#__PURE__*/React.createElement(Layout, {
      variant: "grid",
      gridTemplateColumns: variant === 'withCircularProgress' ? ['1fr auto', '1fr auto', '1fr auto', '1fr auto', null] : ['1fr', '1fr', '1fr', '1fr auto', null],
      alignItems: "center",
      gap: 4
    }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "p4",
      fontSize: "12px",
      letterSpacing: "0.75px",
      textTransform: "uppercase"
    }, item.label), /*#__PURE__*/React.createElement(Typography, {
      variant: textStyle
    }, " ", item.heading), item.progress !== undefined && /*#__PURE__*/React.createElement(Typography, {
      variant: "p1"
    }, " ", item.description)), /*#__PURE__*/React.createElement(Layout, {
      variant: "grid",
      gridTemplateColumns: ['1fr', null, '1fr auto', null, null],
      alignItems: "center",
      columnGap: 4
    }, variant !== 'withCircularProgress' && item.progress !== undefined && /*#__PURE__*/React.createElement(Layout, {
      width: ['auto', null, null, 32, '2xs'],
      pt: 2
    }, /*#__PURE__*/React.createElement(Progress, {
      labelPosition: "bottom",
      value: item.progress
    })), item.children, item.button && /*#__PURE__*/React.createElement(Layout, {
      alignSelf: "center"
    }, item.hasIconButton ? /*#__PURE__*/React.createElement(IconButton, _extends({
      icon: {
        iconName: 'chevron-right'
      },
      variant: 'tertiary',
      isRound: true
    }, item.button)) : /*#__PURE__*/React.createElement(Button, item.button))))));
  }));
};

ContentList.displayName = "ContentList";
export { ContentList };